import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import { Typography } from '@mui/material';

interface IChartProps {
  countryData: any;
  selectedIndex: any;
}

const WatchlistChart: React.FC<IChartProps> = ({
  countryData,
  selectedIndex,
}) => {
  const labels: any = [];
  const docCount: number[] = [];
  const colors = [
    '#3B82F6',
    '#FACC15',
    '#A855F7',
    '#F59E0B',
    '#EC4899',
    '#737373',
  ];
  if (selectedIndex === 'Watchlist') {
    countryData.data.countryAgg.buckets.map((country: any, index: number) => {
      if (index < 5) {
        labels.push({ country: country.key, color: colors[index] });
        docCount.push(country.doc_count);
      } else if (index === 5) {
        labels.push({ country: 'Other', color: colors[index] });
        docCount.push(country.doc_count);
      } else {
        docCount[5] = docCount[5] + country.doc_count;
      }
    });
  }

  if (selectedIndex === 'Country Risk') {
    countryData.data.countryAgg.buckets.map((country: any, index: number) => {
      if (index < 5) {
        labels.push({ country: country.key, color: colors[index] });
        docCount.push(country.doc_count);
      } else if (index === 5) {
        labels.push({ country: 'Other', color: colors[index] });
        docCount.push(country.doc_count);
      } else {
        docCount[5] = docCount[5] + country.doc_count;
      }
    });
  }
  const chartData = {
    datasets: [
      {
        data: docCount,
        backgroundColor: [
          '#3B82F6',
          '#FACC15',
          '#A855F7',
          '#F59E0B',
          '#EC4899',
          '#737373',
        ],
        borderWidth: 0,
        cutout: '75%',
        radius: '65%',
      },
    ],
  };
  return (
    <div className='chart-container'>
      <div className='chart-data'>
        <Doughnut data={chartData} />
        <div className='chart-total'>
          <Typography
            style={{
              fontSize: '16px',
              fontFamily: 'Inter',
              color: '#737373',
              fontWeight: 500,
            }}
          >
            Total Sources
          </Typography>
          {selectedIndex === 'Watchlist' && (
            <Typography style={{ textAlign: 'center', fontSize: '36px', fontFamily: 'Inter', color: 'var(--text-primary)', fontWeight: 600 }}>{countryData.data.countryAgg.buckets.length}</Typography>
          )}
          {selectedIndex === 'Country Risk' && (
            <Typography style={{ textAlign: 'center', fontSize: '36px', fontFamily: 'Inter', color: 'var(--text-primary)', fontWeight: 600 }}>{countryData.data.countryAgg.buckets.length}</Typography>
          )}
        </div>
      </div>
      <div className='chart-labels'>
        {labels.map((label: any, index: number) => (
          <div key={index} className='chart-label-item'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
            >
              <circle cx='6' cy='6' r='6' fill={label.color} />
            </svg>
            <Typography style={{ fontWeight: '500', fontSize: '15px', fontFamily: 'Inter', color: 'var(--text-primary-white)' }}>{label.country}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WatchlistChart;
